module.exports = __webpack_public_path__ + "fonts/iconfont.1d3d3e94.ttf";